module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "tab"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0005#rtab"
    }
  }, [_vm._v("Tables")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0011#tab01",
      "id": "rtab01"
    }
  }, [_vm._v("1. Anonymous and Named Persons in Mark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0011#tab02",
      "id": "rtab02"
    }
  }, [_vm._v("2. Anonymous and Named Persons in Luke")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0011#tab03",
      "id": "rtab03"
    }
  }, [_vm._v("3. Anonymous and Named Persons in Matthew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0011#tab04",
      "id": "rtab04"
    }
  }, [_vm._v("4. Anonymous and Named Persons in John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0011#tab05",
      "id": "rtab05"
    }
  }, [_vm._v("5. Names in the Four Gospels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0012#tab06",
      "id": "rtab06"
    }
  }, [_vm._v("6. The 99 Most Popular Male Names among Palestinian Jews, 330 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v("–200 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0012#tab07",
      "id": "rtab07"
    }
  }, [_vm._v("7. The 31 Most Popular Female Names among Palestinian Jews, 330 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v("–200 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0012#tab08",
      "id": "rtab08"
    }
  }, [_vm._v("8. Index of Palestinian Jewish Male Names in the Gospels and Acts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0012#tab09",
      "id": "rtab09"
    }
  }, [_vm._v("9. Index of Palestinian Jewish Female Names in the Gospels and Acts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0013#tab10",
      "id": "rtab10"
    }
  }, [_vm._v("10. The Names of the Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0014#tab11",
      "id": "rtab11"
    }
  }, [_vm._v("11. Named Persons in the Gospel of Mark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0014#tab12",
      "id": "rtab12"
    }
  }, [_vm._v("12. Named Persons in Lucian’s "), _c('em', [_vm._v("Alexander")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0014#tab13",
      "id": "rtab13"
    }
  }, [_vm._v("13. Named Persons in Porphyry’s "), _c('em', [_vm._v("Life of Plotinus")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0015#tab14",
      "id": "rtab14"
    }
  }, [_vm._v("14. The Plural-to-Singular Narrative Device in the Synoptic Gospels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0015#tab15",
      "id": "rtab15"
    }
  }, [_vm._v("15. The Plural-to-Singular Narrative Device and References to Peter in the Gospel of Mark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0025#tab16",
      "id": "rtab16"
    }
  }, [_vm._v("16. Named Apostles in Irenaeus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0025#tab17",
      "id": "rtab17"
    }
  }, [_vm._v("17. Sources of Irenaeus’s Knowledge of John the Disciple of the Lord")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31db8a60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-bauckham-0006.vue
// module id = 69
// module chunks = 0